import { render, staticRenderFns } from "./ThumbnailSlotLargeHorizontal.vue?vue&type=template&id=246de8ba"
import script from "./ThumbnailSlotLargeHorizontal.vue?vue&type=script&lang=js"
export * from "./ThumbnailSlotLargeHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports